const changeCreditLimitDialogStyle = () => ({
	creditLimitBody: {
		minHeight: '400px',
	},
	numberInfo: {
		padding: '20px 0 28px 0',
	},
	creditLimitInput: {
		width: '114px',
		margin: '0 auto 24px auto',
	},
	errorBoxWrapper: {
		width: '296px',
		margin: '0 auto 26px auto',
	},
	otpWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
});

export default changeCreditLimitDialogStyle;
